var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4987 5.25833V1.25H7.4987V5.25833C6.00703 6.125 4.9987 7.73333 4.9987 9.58333C4.9987 12.3417 7.24037 14.5833 9.9987 14.5833C12.757 14.5833 14.9987 12.3417 14.9987 9.58333C14.9987 7.73333 13.9904 6.125 12.4987 5.25833ZM0.832031 8.75H3.33203V10.4167H0.832031V8.75ZM2.95768 15.4502L4.13268 16.6252L5.62435 15.1252L4.44935 13.9502L2.95768 15.4502ZM10.832 18.7083V16.25H9.16536V18.7083H10.832ZM16.6654 10.4167V8.75H19.1654V10.4167H16.6654ZM14.3656 15.1331L15.8572 16.6331L17.0322 15.4581L15.5322 13.9665L14.3656 15.1331Z",
    fill: "#3A4861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLight);
export default __webpack_public_path__ + "static/media/Light.08f54cbdd0787266b03714fbc542c142.svg";
export { ForwardRef as ReactComponent };